import {
  appendGOATandCountryCodeToTitle,
  getCategories,
  getText,
} from 'shared/utils/pageMetadataUtils';
import { startCase } from 'shared/utils/startCase';

export const getCollectionsMetadata = ({
  pageTitle,
  pageDescription,
  constructorResponse,
  locale,
  query,
}) => {
  // Pulling out static strings for translation purposes
  const shopTheCurated = 'Shop the curated';
  const collection = 'collection';
  const onGOAT = 'on GOAT';
  const more = 'More';
  const buyerProtectionGuaranteedOnAllPurchases = 'Buyer protection guaranteed on all purchases';
  const featuring = 'Featuring';

  const { groups = [] } = constructorResponse?.response || {};
  const { topLevelCategories } = getCategories(groups);

  const featuringTopCategories = getText(`${featuring}`, topLevelCategories.constructedList);
  let topCategoriesWithMore = topLevelCategories.constructedListWithStartCase;
  if (topCategoriesWithMore.length === 5 || topCategoriesWithMore.length === 3) {
    topCategoriesWithMore.splice(-1, 1, more);
  } else if (topCategoriesWithMore.length === 1) {
    topCategoriesWithMore = [...topCategoriesWithMore, ' & ', more];
  }

  const collectionName: string = pageTitle.split(' | ')[0] || startCase(query?.slug);
  const title = getText(`${collectionName}: `, topCategoriesWithMore);
  const description = `${shopTheCurated} ${collectionName} ${collection} ${onGOAT}. ${featuringTopCategories}. ${buyerProtectionGuaranteedOnAllPurchases}.`;

  return {
    pageTitle: appendGOATandCountryCodeToTitle(title, locale),
    pageDescription: pageDescription || description,
  };
};
